import { Configuration, ConfigurationParameters } from '@citruscamps/citrus-client'
import { getLocalStorageItem } from './local-storage'

export const generateApiConfig = (configuration: ConfigurationParameters = {}) => {
  configuration.accessToken = getLocalStorageItem('access_token')?.access_token
  configuration.basePath = process.env.REACT_APP_API_BASE_URL
  configuration.credentials = 'include'
  return new Configuration(configuration)
}
